import { ArrayKeyValueObject, KeyValueObject } from "@/UI/Interfaces/IBaseUI";
import classNames from "classnames";
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { HiOutlineMinus, HiOutlinePlus } from "react-icons/hi";

const MenuItem = forwardRef((
    { menuItem }:
        { menuItem: KeyValueObject },
    ref
) => {
    const isActive = menuItem.activeMenu === menuItem.id;
    const hasSubMenu = menuItem?.subMenu?.length >= 1;
    const subMenuRef = useRef(null);

    useImperativeHandle(ref, () => ({
        closeMenu: () => {
            if (isActive) {
                menuItem.setActiveMenu("");
            }
        },
    }));

    const handleClick = () => {
        menuItem.handleClick(menuItem, subMenuRef);
        menuItem?.onClick?.(menuItem, subMenuRef);
    }

    if (menuItem?.hide)
        return null;

    return (
        <>
            <li
                className={classNames(["aside-item", { active: isActive }])}
                onClick={handleClick}
            >

                {
                    typeof (menuItem?.icon) == "string" ? (
                        <span dangerouslySetInnerHTML={{ __html: menuItem.icon }} />
                    ) : (
                        <span>
                            {menuItem?.icon}
                        </span>
                    )
                }

                <p className="ms-2">{menuItem.title}</p>

                {hasSubMenu &&
                    (isActive ? (
                        <HiOutlineMinus size="18" className="submenu-icon ms-auto" />
                    ) : (
                        <HiOutlinePlus size="18" className="submenu-icon ms-auto" />
                    ))}
            </li>

            {
                hasSubMenu ? (
                    <Menu ref={subMenuRef} menu={menuItem.subMenu} isSubMenu={true} showSubMenu={isActive} />
                ) : null
            }
        </>
    )
})


const Menu = forwardRef((
    { className, menu, isSubMenu, showSubMenu, forcePinSideBar }:
        { className?: string, menu: ArrayKeyValueObject, isSubMenu: boolean, showSubMenu?: boolean, forcePinSideBar?: () => void },
    ref) => {
    const [activeMenu, setActiveMenu] = useState<string>("");
    const menuItemRefs: any = useRef([]);
    useEffect(() => {
        let activeId = menu.find(menuItem => menuItem.routeTo == location.pathname)?.id || "";
        setActiveMenu(activeId);
    }, [location])

    const handleClick = (m: any, subMenuRef: any) => {
        if (activeMenu == m.id) {
            const hasSubMenu = m?.subMenu?.length >= 1;

            if (!hasSubMenu) {
                let activeId: any = menu.find(menuItem => menuItem.routeTo == location.pathname)?.id;
                setActiveMenu(activeId);
            }
            else {
                setActiveMenu("");
                subMenuRef.current?.closeMenu();
            }


        }
        else {
            setActiveMenu(m.id);
            forcePinSideBar?.();
            subMenuRef.current?.closeMenu();
        }
    }

    const closeMenu = () => {
        setActiveMenu("");

        menuItemRefs.current.forEach((menuItemRef: any) => {
            menuItemRef.closeMenu();
        });
    }

    useImperativeHandle(ref, () => ({
        closeMenu
    }));

    return (
        <ul className={classNames(["aside-menu", className && className, { "aside-sub-menu": isSubMenu, "show": showSubMenu }])}>
            {
                menu.map((menuItem, idx) => (
                    <MenuItem key={idx + menuItem.id} ref={el => menuItemRefs.current[idx] = el} menuItem={{ ...menuItem, activeMenu, setActiveMenu, handleClick, showIcon: isSubMenu ? false : true }} />
                ))
            }
        </ul>
    )
})

export default Menu;